/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_NameInputs */

const en_tables_custom_pages_name = /** @type {(inputs: Tables_Custom_Pages_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Name`)
};

const de_tables_custom_pages_name = /** @type {(inputs: Tables_Custom_Pages_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Pages Name" |
*
* @param {Tables_Custom_Pages_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_name = /** @type {((inputs?: Tables_Custom_Pages_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_name(inputs)
	return de_tables_custom_pages_name(inputs)
});